import React from 'react';

export function Thailand(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="513" height="342" fill="#A51931"/>
      <rect x="0" y="57" width="513" height="228" fill="white"/>
      <rect x="0" y="114" width="513" height="114" fill="#2D2A4A"/>
    </svg>
  );
}
